var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Spin } from 'antd';
import { Color } from '../../constants';
export var StyledSpinner = styled(Spin)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  z-index: 1000;\n  position: ", " !important;\n"], ["\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  z-index: 1000;\n  position: ", " !important;\n"])), Color.PRIMARY_LIGHT, function (_a) {
    var isFullScreen = _a.styled.isFullScreen;
    return isFullScreen ? 'fixed' : 'absolute';
});
var templateObject_1;
//# sourceMappingURL=style.js.map